/** Prepends a carousel slide when the feature gate is on (shared by AppSumo / non-AppSumo lists). */
export const prependRebrandCarouselSlide = (slides, shouldPrepend, slide) =>
  shouldPrepend ? [slide, ...slides] : slides;
